import { render, staticRenderFns } from "./CompetitionsList.vue?vue&type=template&id=1aa634e9&scoped=true&"
import script from "./CompetitionsList.vue?vue&type=script&lang=js&"
export * from "./CompetitionsList.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionsList.vue?vue&type=style&index=0&id=1aa634e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa634e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemActionText } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VDivider,VIcon,VList,VListGroup,VListItem,VListItemAction,VListItemActionText,VListItemAvatar,VListItemContent,VListItemTitle})
